import { defineStore } from "pinia";
import { reactive } from "vue";
import AzureGraphDataFetcher from "@/services/connectors/azureGraphConnector";
import { useAuthenticationStore } from "./authentication";
import { PageDescription } from "@/types/PageDescriptionListItem";

interface SharePointResponse {
  value: {
    fields: {
      ReportLink: { Url: string };
      Title: string;
      DescriptionId: number;
    };
  }[];
}

export const useEmbedStore = defineStore("embed", () => {
  const state = reactive({
    status: 0,
    url: "",
    name: "",
    description: "",
    link: "",
    descriptionId: 0,
  });
  const graph = new AzureGraphDataFetcher(
    useAuthenticationStore().getTokenLoaded()
  );

  const loadReportData = async (url: string) => {
    state.url = url;
    const result = await graph.getReportLink(state.url);
    const pageTitle = result.value[0].fields.Title;
    if (pageTitle) {
      document.title = document.title + " - " + pageTitle;
    }
    const response = result as SharePointResponse;
    if (!response || !response.value || response.value.length === 0) {
      console.error("No report link found for the provided URL.");
      return false;
    }

    state.link = response.value[0].fields.ReportLink.Url;
    state.name = response.value[0].fields.Title;
    state.descriptionId = response.value[0].fields.DescriptionId;

    return true;
  };

  async function getPageDescription(): Promise<PageDescription | undefined> {
    try {
      const result = await graph.getPageDescription(`${state.descriptionId}`);

      if (!result) {
        console.error("No page description found for the provided ID.");
        return undefined;
      }
      return result.fields as PageDescription;
    } catch (error) {
      console.error("Error fetching page description:", error);
      throw error;
    }
  }

  function getReportLink(): string {
    return state.link;
  }

  function getReportName(): string {
    return state.name;
  }

  function getDescriptionId(): string {
    return `${state.descriptionId}`;
  }

  return {
    state,
    getPageDescription,
    getReportLink,
    getReportName,
    getDescriptionId,
    loadReportData,
  };
});
